import * as React from "react";
import { default as NumberFormat } from 'react-number-format';
import './FormInput.css'

interface IProps {
    label?: string;
    errorLabel?: any,
    showError?: boolean | string;
    placeholder?: string;
    autoFocus?: boolean;
    isDisabled?: boolean;
    isAmount?: boolean;
    isNumber?: boolean;
    isPhoneNumber?: boolean;
    onFocusOut?: () => void;
    change: (e: any) => void;
    val?: any;
    isLocked?: boolean;
    maxChars?: number
}

export default class FormInput  extends React.Component<
    IProps
    > {

    public digitsError: boolean = false;
    public digitsErrorText: string = "Please enter valid digits";

    public renderLabel = () => {
        const { label } = this.props;
        const inputLabel = label? <div className="label">{label} </div>: null;
        return inputLabel? <div className="input-label">
            {inputLabel}
        </div> : null
    };

    public onChange = (e: any) => {
        const {change, isAmount, isNumber} = this.props;
        const value = e.target.value;
        if (isAmount) {
            change(this.parseNumbers(value))
        }else if (isNumber) {
            if(this.isValidNumberInput(value)) {
                change(value);
            }else {
                return;
            }
        }
        else {
            change(value);
        }
    };

    public getError = () => {
        const {errorLabel, showError} = this.props;
        if(errorLabel && showError) {
            return <div className="error-label"> {errorLabel} </div>;
        }
        return null
    }

    public renderInput = () => {
        const { autoFocus, isDisabled, placeholder, isAmount, onFocusOut, val, isLocked, isPhoneNumber} = this.props;
        const dollarIcon = isAmount?  <div className= {"icon-container" + " " + (isLocked? "locked": "")} > $ </div> : "";
        const inputClasses = isAmount? "input-icon": " ";
        const error = this.getError();
        const errorClass = error? "error-frame": "";
        return (<>
            <div className={"input " + inputClasses + " " + errorClass + " " + (isLocked? "locked": "")}>
                {dollarIcon}
                {isPhoneNumber? <NumberFormat format="(###) ###-####"  onChange={this.onChange} autoFocus={autoFocus} placeholder={placeholder} disabled={isDisabled || isLocked} onBlur={onFocusOut} value={val}/>:
                    <input onChange={this.onChange} autoFocus={autoFocus} placeholder={placeholder} disabled={isDisabled || isLocked} onBlur={onFocusOut} value={val}/>}
            </div>
            {error}
        </>);
    };

    public render() {
        return (
            <div className="input-container">
                {this.renderLabel()}
                <div className="text-input-container">
                    {this.renderInput()}
                </div>
            </div>
        );
    };

    private parseNumbers = (value: string) => {
        const parsedVal = value.replace( /,/g, "" );
        if(isNaN(parseInt(parsedVal, 10))) {
            return ''
        }
        return parseInt(parsedVal, 10).toLocaleString() || '';
    }

    private isValidNumberInput = (value: any) => {
        const {maxChars} = this.props;
        if(/^\d+$/.test(value) || value === ""){
            if(maxChars) {
                if(maxChars >= value.length) {
                    return true;
                }
            }else {
                return true;
            }
        }
        return false;
    }
}




// WEBPACK FOOTER //
// ./src/components/FormInput/FormInput.tsx